// Activate account
const PRIVILEGE_GRANT_TOKEN = token => `/privilegeGrantToken/${token}`;
export default PRIVILEGE_GRANT_TOKEN;